import React, { useState, useEffect } from 'react';
import './CustomLoader.css';

export default function CustomLoader({ loading }) {
    const messages = [
        "Securing your policy details...",
        "Verifying your information...",
        "Finalizing your request...",
        "Almost ready..."
    ];

    const [currentMessage, setCurrentMessage] = useState(0);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (!loading) {
          setCurrentMessage(0);
          setProgress(0);
          return;
        }
        
        const messageInterval = setInterval(() => {
            setCurrentMessage((prev) => (prev + 1) % messages.length);
        }, 2000);

        const progressInterval = setInterval(() => {
            setProgress(prev => prev < 90 ? prev + 10 : prev);
        }, 500);

        return () => {
            clearInterval(messageInterval);
            clearInterval(progressInterval);
        };
    }, [messages.length, loading]);

    return (
        loading && (
            <div className="insurance-loader" aria-live="polite">
                <div className="loader-content">
                    <div className="shield-container">
                        <div className="shield-spinner" />
                        <div className="shield-icon">
                            <i className="fas fa-shield-alt" aria-hidden="true"></i>
                        </div>
                    </div>
                    <p className="loading-text">{messages[currentMessage]}</p>
                    <div className="progress-container">
                        <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                    </div>
                    <p className="progress-text">{progress}%</p>
                </div>
            </div>
        )
    );
}
